import Image from 'next/image';
import clsx from 'clsx';
import { CardData } from '@/sections/product/components/TimerTabsVertical/index';
import './CardScroller.scss';

type CardScrollerProps = {
  cardData: CardData[];
  showImageIndex: number;
};

export function CardScroller({ cardData, showImageIndex }: CardScrollerProps) {
  return (
    <div className="relative h-full">
      {cardData.map((card, index) => {
        return (
          <div className="absolute right-0 top-0 h-full w-full" key={card.title}>
            <Image
              src={card.desktopImg}
              alt={card.imageAlt}
              className={clsx(
                'object-fit absolute h-full rounded-3xl',
                showImageIndex === index ? 'transition-card-in' : 'transition-card-out',
              )}
            />
          </div>
        );
      })}
    </div>
  );
}
